import React from 'react';
import {
  PropTypes,
  oneOf,
  shape,
  node,
  number,
  string,
  arrayOf
} from 'prop-types';
import { TYPES } from 'envs/core.js';
import Limiter from 'components/limiter/index.js';
import SCPactometroBarras from './pactometroBarras.js';
import { customAcronym } from '../../constants';

export const PactometroBarrasSimple = ({
  data,
  totalSeat,
  selecteds,
  centerProps,
  title,
  height,
  type
}) => {
  const selectedData = data.filter(item =>
    selecteds.some(select => select === item.id)
  );

  const { seat } = selectedData.reduce(
    (ac, current) => ({
      seat: ac.seat + current.seats,
      percent: ac.percent + current.percent
    }),
    { seat: 0, percent: 0 }
  );

  return (
    <SCPactometroBarras height={height} className="bloque-pactometro-container">
      <div className="bloque-pactometro">
        <p className="total-pactometro">
          {title || (
            <React.Fragment>
              {type === TYPES.MUNICIPAL
                ? 'Total concejales: '
                : 'Total escaños: '}
              <span id="" className="total-pactometro-value">
                {seat}
              </span>
            </React.Fragment>
          )}
        </p>
        <div
          id="barra"
          className="porcentaje-pactometro bloque-pactometro-barra"
        >
          <Limiter />
          <div
            className={`mayoria-pactometro-barras ${centerProps.position} ${centerProps.lineStyle}`}
          >
            <p>
              {centerProps.text || (
                <React.Fragment>
                  Mayoría absoluta: {parseInt(totalSeat / 2, 0) + 1 || 176}{' '}
                  {type === TYPES.MUNICIPAL ? 'concejales' : 'escaños'}
                </React.Fragment>
              )}
            </p>
          </div>
          {selectedData.map(element => (
            <div
              className="partido"
              key={customAcronym(element)}
              title={customAcronym(element)}
              style={{
                width: `${(100 / totalSeat) * element.seats}%`,
                backgroundColor: element.partyColor
              }}
            >
              {element.seat}
            </div>
          ))}
        </div>
      </div>
    </SCPactometroBarras>
  );
};
PactometroBarrasSimple.defaultProps = {
  centerProps: { position: 'down', lineStyle: 'dashed' },
  height: 46
};

PactometroBarrasSimple.propTypes = {
  height: number,
  title: oneOf([node, string]),
  data: arrayOf(
    shape({
      partyAcronym: string.isRequired,
      seats: number.isRequired,
      partyColor: string.isRequired,
      id: number.isRequired
    })
  ).isRequired,
  selecteds: arrayOf(PropTypes.number),
  totalSeat: number.isRequired,
  centerProps: shape({
    position: oneOf(['up', 'down']),
    lineStyle: oneOf(['dashed', 'solid']),
    text: oneOf([string, node])
  })
};

export default PactometroBarrasSimple;
